import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  class: "header",
  src: "https://static-s.theckb.com/BusinessMarket/Client/1688national/national_suggest_bg.png",
  alt: ""
}, null, -1)
const _hoisted_3 = { class: "inputBox" }
const _hoisted_4 = { class: "label" }
const _hoisted_5 = { class: "operate fle-cen" }

import { t } from '@/plugins/i18n'
import { ref, watch, onMounted, reactive, nextTick } from 'vue'
import type { FormInstance, FormRules } from 'element-plus'
interface RuleForm {
  comments: string
}


export default /*#__PURE__*/_defineComponent({
  props: ['visible'],
  emits: ['close'],
  setup(__props, { emit }) {

const props = __props


watch(() => props.visible, (val) => {
  if (val) {
    ruleForm.comments = ''
    formRef.value?.clearValidate()
  }
})

const ruleForm = reactive<RuleForm>({
  comments: ''
})
const formRef = ref<FormInstance>()
const rules = reactive<FormRules<RuleForm>>({
  comments: [{
    required: true,
    message: '※必須項目です',
    trigger: 'change'
  }]
})
/** 关闭弹窗 */
const closeDialog = () => {
  emit('close')
}
/** 提交数据 */
const submit = () => {
  formRef.value?.validate((vaild) => {
    console.log(vaild)

    if (vaild) {
      emit('close', ruleForm.comments)
    }
  })
}
/** 取消数据 */
const cancel = () => {
  emit('close')
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "close-on-click-modal": false,
    "append-to-body": "",
    "destroy-on-close": "",
    "show-close": false,
    "custom-class": "natial-suggest-modal",
    modelValue: __props.visible,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(visible) ? (visible).value = $event : null)),
    width: "500px"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)('请说说你的不满意的点，以便我们改进')), 1),
          _createVNode(_component_el_form, {
            model: _unref(ruleForm),
            ref: (_value, _refs) => {
              _refs['formRef'] = _value
              formRef.value = _value
            },
            rules: _unref(rules)
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { prop: "comments" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    ref: (_value, _refs) => {
                      _refs['inputRef'] = _value
                    },
                    resize: "none",
                    class: "textarea",
                    maxlength: "200",
                    modelValue: _unref(ruleForm).comments,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(ruleForm).comments) = $event)),
                    modelModifiers: { trim: true },
                    type: "textarea"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model", "rules"]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_el_button, { onClick: cancel }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('取消')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              style: {"color":"#fff"},
              class: "submit",
              color: "#FF4000",
              onClick: submit
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('提交')), 1)
              ]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})